module.exports = __webpack_public_path__ + "img/header-admin.70651914.png";